import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function ConditionDetailPage() {
  const [condition, setCondition] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    axios.get(`${API_URL}/api/conditions/${slug}`)
      .then(res => setCondition(res.data))
      .catch(err => console.error("Error fetching condition:", err));
  }, [slug]);

  if (!condition) {
    return <div className="container">Laster inn...</div>;
  }

  return (
    <div className="condition-detail-layout">
      <Helmet>
      <title>{`Behandling av ${condition.name} i Førde – Sunnfjord Naprapatsenter`}</title>
      <meta name="description" content={condition.short_description} />
    </Helmet>
      <div className="image-column">
        <img src={condition.image_url} alt={condition.name} />
      </div>
      <div className="text-column">
        <h1>{condition.name}</h1>
        
        {/* --- VIKTIG ENDRING HER --- */}
        {/* Viser nå HTML-innholdet direkte */}
        <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(condition.long_description) }} />
      </div>
    </div>
  );
}

export default ConditionDetailPage;